// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/whiteout.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/whiteout/whiteout.js';

mount([g0]);
